function getCookie (name) {
  let cookieValue = null
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  return cookieValue
}

export function  getCSRFToken() {
    var csrf = getCookie('csrftoken');
    if (csrf)
        return csrf;

    // If the csrf is missing for any reason just try and grab another
    fetch("/_allauth/browser/v1/auth/session")
}
